module.exports = __webpack_public_path__ + "img/agas_no.f31e204c.png";